import script from "./QuestionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionsView.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionsView.vue?vue&type=style&index=0&id=f17b7f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f17b7f80"]])

export default __exports__